import { protectedReq } from '../../helpers/requestHelper';

export const getMedicalCoupons = async () => {
    try {
        const response = await protectedReq('coupon/list?scope=medical');
        const body = await response.json();
        if (!body.status) return { status: false, coupons: [] };
        return {
            status: true,
            coupons: body.resp.coupons
        };
    } catch (err) {
        return { status: false, coupons: [] };
    }
};

export const getMedicalCouponReport = async ({ doctor_id = '', executive_id = '', mine = false } = {}) => {
    try {
        const params = new URLSearchParams();
        if (doctor_id) params.set('doctor_id', doctor_id);
        if (executive_id && executive_id !== 'mine') params.set('executive_id', executive_id);
        const query = params.toString();
        const endpoint = mine || executive_id === 'mine' ?
            'order/my-medical-coupon-summary'
        : 'order/medical-coupon-report';
        const response = await protectedReq(
            `${endpoint}${query ? `?${query}` : ''}`
        );
        return await response.json();
    } catch (err) {
        return { status: false, msg: 'request-err' };
    }
};

export const getMedicalCouponOrderDetail = async (orderId, mine = false) => {
    try {
        const endpoint = mine ? 'order/my-medical-coupon-summary' : 'order/medical-coupon-report';
        const response = await protectedReq(`${endpoint}/${orderId}`);
        return await response.json();
    } catch (err) {
        return { status: false, msg: 'request-err' };
    }
};

export const updateMedicalCouponAvailability = async model => {
    try {
        const response = await protectedReq('coupon/medical-availability', model, 'PATCH');
        return await response.json();
    } catch (err) {
        return { status: false, msg: 'request-err' };
    }
};
